<template>

  <div>

    <b-card>

      <b-row>
        <b-col cols="12">

          <b-tabs
            pills
          >

            <!-- Tab: Account -->
            <b-tab active>
              <template #title>
                <feather-icon
                  icon="UploadCloudIcon"
                  size="16"
                  class="mr-0 mr-sm-50"
                />
                <span class="d-none d-sm-inline">Subir Seriales</span>
              </template>
              <upload-sims-form 
                class="mt-2 pt-75"
              />
            </b-tab>
            
          </b-tabs>

          
        </b-col>
      </b-row>

    </b-card>

  </div>

</template>

<script>
import router from '@/router'
import { BRow, BCol, BTabs, BTab, BCard } from 'bootstrap-vue'
import UploadSimsForm from './UploadSimsForm.vue'

export default {
  components: {
    BRow,
    BCol,
    BTabs,
    BTab,
    BCard,

    UploadSimsForm,
  },
  data() {
    return {
    }
  },
  created() {
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>